<!-- eslint-disable prettier/prettier -->
<div class="error-dialog">
	<div class="error-dialog__content">
		<div class="error-dialog__icon-wrapper">
			<lucide-icon
				name="triangle-alert"
				[size]="42"
				[strokeWidth]="2"
				class="error-dialog__icon"
			></lucide-icon>
		</div>
		<h2 class="error-dialog__title">{{ title }}</h2>
		@if (message) {
		<p class="error-dialog__message">{{ message }}</p>
		} @else {
		<p class="error-dialog__message">
			<strong>Alguno de los datos ingresados ya está registrado.</strong> <br />Si ya
			tenés una cuenta, iniciá sesión o recuperá tu contraseña.
		</p>
		}
		<button mat-raised-button class="error-dialog__btn" (click)="cerrar()">Cerrar</button>
	</div>
</div>
